const payment = {
    number: "",
    expiry: "",
    security_code: "",
    name: "",
    acknowledgement: "",
}

export default payment